<template>
  <div>
    <!-- title -->
    <div class="ex1">
      <h3 class="subtitle">
        {{ title }}
      </h3>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        :params="params"
        @cell-click="tableCellClicked"
        @on-row-dblclick="onRowDoubleClick"
        @row-click="onRowClicked"
        @cell-contextmenu="cm"
        ><template v-slot:column-1="{ props }">
          <span :style="{ color: props.cellData.color }">{{
            props.cellData.value
          }}</span> </template
        ><template v-slot:column-6="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          > </template
        ><template v-slot:column-7="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          >
        </template>
      </vue-table-dynamic>
    </div>

    <div class="top-margin" v-if="dailyLog[0]">
      <h1 class="title is-4">Vrijeme provedeno na pauzi:</h1>
      <brake-listing :insideEvents="dailyLog[0].insideEvent" />
    </div>
  </div>
</template>

<script>
import VueTableDynamic from "vue-table-dynamic";
import BrakeListing from "./BrakeListing.vue";

import {
  getDepartmentFromEmployeeId,
  getDateFromTicks,
  maskIfEquealsValue,
  getStartedYesterdayStayString,
  getStayedTillTomorrowString,
  //   getDailyLogsFromDepartmentId,
  // getStatusCodeFromStatusId,
} from "../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ecfeff",
];

export default {
  name: "DailyLogTable",

  props: {
    dailyLog: Array,
    title: String,
  },

  components: {
    VueTableDynamic,
    BrakeListing,
  },

  data() {
    return {
      params: {
        data: [
          [
            "Index",
            "Datum",
            "Ime i prezime",
            "Sektor",
            "Dolazak",
            "Odlazak",
            "Izlasci",
            "Pauza",
            "U zgradi",
            "Van zgrade",
            "Ukupno",
            // "status",
            "Komentar",
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 2, width: "15%" },
        ],
      },
    };
  },

  mounted() {
    console.log(this.dailyLog);

    this.arrangeData();
  },

  methods: {
    tableCellClicked() {},

    arrangeData() {
      let ndx = 1;
      this.dailyLog.forEach((element) => {
        // first calculate insideEvent data
        element.insideEvent.forEach((ie) => {
          if (ie.isLogicallyClosed) {
            element.insideEventLength += ie.duration;
          }
        });
        // then push the data
        this.params.data.push([
          ndx++,
          {
            value: new Date(element.logDate).toLocaleDateString("sr-latn-cs"),
            id: `${1}`,
            color: colors[0],
          },
          this.$store.state.general.employees.find(
            (x) => x.id === element.employeeId
          ).name,
          getDepartmentFromEmployeeId(
            this.$store.state.general.departmentData,
            element.employeeId
          ),
          maskIfEquealsValue(
            new Date(element.arrivalTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          ) + getStartedYesterdayStayString(element),
          maskIfEquealsValue(
            new Date(element.departureTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          ) + getStayedTillTomorrowString(element),
          {
            value: maskIfEquealsValue(element.outsideEvent.length, "0"),
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          {
            value: maskIfEquealsValue(element.insideEventlength, "0"),
            id: `${1}`,
            color: element.insideEventlength > 0 ? colors[1] : colors[0],
            decoration: element.insideEventlength > 0 ? "underline" : "none",
            cursor: element.insideEventlength > 0 ? "zoom-in" : "default",
          },
          maskIfEquealsValue(
            getDateFromTicks(element.workhoursInsideBuildingThisDay),
            "00:00:00"
          ),
          maskIfEquealsValue(
            getDateFromTicks(element.workhoursOutsideBuildingThisDay),
            "00:00:00"
          ),
          maskIfEquealsValue(
            getDateFromTicks(element.totalWorkhoursThisDay),
            "00:00:00"
          ),
          // getStatusCodeFromStatusId(element.statusId, this.statuses),
          maskIfEquealsValue(
            maskIfEquealsValue(element.note, "null"),
            "undefined"
          ),
        ]);
      });
    },
    onRowDoubleClick() {},
    onRowClicked() {},
    cm() {},
  },
};
</script>

<style scoped>
.top-margin {
  margin-top: 20px; /* Adjust this value as needed */
}
</style>